import React from 'react'
import Cards from './Cards'
import BookingsPieChart from './BookingsPieChart'
import TableUserProvider from './TableUserProvider'
import BookingsPerMonth from './BookingsPerMonth'

const MainDashboard = () => {
  return (
    <div className='flex-center gap-4' style={{ flexFlow: 'wrap', minWidth: 'fit-content' }}>
      <Cards/> 
      <TableUserProvider/>
      <BookingsPieChart/>
      <BookingsPerMonth/>
    </div>
  )
}

export default MainDashboard